import { render, staticRenderFns } from "./DownloadFileBtn.vue?vue&type=template&id=c778ce26&"
import script from "./DownloadFileBtn.js?vue&type=script&lang=js&"
export * from "./DownloadFileBtn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports